import { useEffect } from 'react';
import { useAppDispatch } from '@/store/hooks';
import { decrementGlobalLoading, incrementGlobalLoading } from '@/store/uiSlice';

export function useGlobalLoader(active: boolean) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!active) return;

    dispatch(incrementGlobalLoading());
    return () => {
      dispatch(decrementGlobalLoading());
    };
  }, [active, dispatch]);
}
